// Meta Pixel utility for tracking events
// Pixel ID: 2042623636583188

export function initMetaPixel() {
  if (typeof window === 'undefined') return
  if ((window as any).fbq) return

  const n: any = ((window as any).fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })

  if (!(window as any)._fbq) (window as any)._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  // Load the pixel script
  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(script)

  // Initialize with Pixel ID
  ;(window as any).fbq('init', '2042623636583188')
}

export function trackPageView() {
  if ((window as any).fbq) {
    ;(window as any).fbq('track', 'PageView')
  }
}

export function trackAddToCart() {
  if ((window as any).fbq) {
    ;(window as any).fbq('track', 'AddToCart', {
      content_name: 'PequeSalud Natural',
      content_type: 'product',
      value: 6.39,
      currency: 'USD',
    })
  }
}
